import React, { useEffect, useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import AdminLayout from './components/AdminLayout'
import SimpleHome from './pages/SimpleHome'
import EventbriteClasses from './pages/EventbriteClasses'
import Inventory from './pages/Inventory'
import ArtGallery from './pages/ArtGallery'
import Shopify from './pages/Shopify'
import About from './pages/About'
import Contact from './pages/Contact'
import Admin from './pages/Admin'
import Sitemap from './pages/Sitemap'
// Debug imports removed for production build compatibility
import { serverCacheService } from './utils/serverCacheService'

function App() {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/admin')
  const [isLoading, setIsLoading] = useState(true)

  // Initialize server cache on app startup
  useEffect(() => {
    const initializeCache = async () => {
      try {
        console.log('App: Loading data from server cache...')
        const success = await serverCacheService.initialize()
        
        if (success) {
          console.log('App: Successfully loaded from server cache')
        } else {
          console.log('App: No server cache found - site will show empty until admin syncs data')
        }
      } catch (error) {
        console.error('App: Failed to load server cache:', error)
      } finally {
        setIsLoading(false)
      }
    }

    initializeCache()
  }, [])

  const MainLayout = isAdminRoute ? AdminLayout : Layout

  // Show loading indicator while initializing cache
  if (isLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <h4 className="text-muted">Loading The Salty Mermaid...</h4>
          <p className="text-muted">Preparing your art experience</p>
        </div>
      </div>
    )
  }

  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<SimpleHome />} />
        <Route path="/classes" element={<EventbriteClasses />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/gallery" element={<ArtGallery />} />
        <Route path="/shopify" element={<Shopify />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/sitemap" element={<Sitemap />} />
        {/* Debug routes removed for production build compatibility */}
      </Routes>
    </MainLayout>
  )
}

export default App